import { useEffect, useMemo, useState } from 'react';
import { resolveEvergreenCandidates } from '@/lib/evergreenVideoSource';

/**
 * Bascule sur la copie de secours quand la source échoue, sans course ni surveillance.
 *
 * Version allégée de `useEvergreenVideoSource`, pour les écrans où la vidéo n'est pas jouée en
 * continu face à un spectateur : le back-office s'en sert comme horloge pour poser des timecodes,
 * une ressource cassée doit y trouver son secours mais un gel passager n'a pas à être traqué.
 */
export function useVideoFallbackSource(
  primaryUrl?: string | null,
  fallbackUrl?: string | null,
): { src: string | undefined; onError: () => void } {
  const candidates = useMemo(
    () => resolveEvergreenCandidates(primaryUrl, fallbackUrl),
    [primaryUrl, fallbackUrl],
  );
  const [useFallback, setUseFallback] = useState(false);

  useEffect(() => {
    setUseFallback(false);
  }, [candidates]);

  return {
    src: (useFallback ? candidates.fallbackUrl : candidates.primaryUrl) ?? undefined,
    onError: () => {
      if (candidates.fallbackUrl !== null) setUseFallback(true);
    },
  };
}
